import { AUTH_ENDPOINTS } from "./auth"
import { DNS_ENDPOINTS } from "./dns"
import { SCHEDULE_ENDPOINTS } from "./schedule"
import { ERROR_CAPTURE_API_ENDPOINTS } from "./error-capture"

export const ENDPOINTS = {
  dns: DNS_ENDPOINTS,
  auth: AUTH_ENDPOINTS,
  schedule: SCHEDULE_ENDPOINTS,
  error_capture: ERROR_CAPTURE_API_ENDPOINTS,
}